import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/**
 * notify - función dinámica para mostrar notificaciones
 * @param {Object} options - configuración de la notificación
 * @param {string} options.title - título del mensaje
 * @param {string} options.text - texto del mensaje
 * @param {string} [options.variant='info'] - tipo (success, warning, error, info)
 * @param {string} [options.icon='InfoIcon'] - ícono a mostrar
 * @param {string} [options.position='top-right'] - posición (top-right, top-center, bottom-left, etc.)
 * @param {boolean} [options.quick=false] - si es rápida (sin título, solo texto)
 */
// Función base
const baseNotify = ({
  title,
  text,
  variant = 'info',
  icon = 'InfoIcon',
  position, // sin default aquí
  quick = false,
}) => {
  Vue.$toast(
    {
      component: ToastificationContent,
      props: {
        title: quick ? '' : title,
        text,
        icon,
        variant,
      },
    },
    {
      position: position || 'top-right', // ahora sí se respeta
      timeout: quick ? 2000 : 5000,
      closeOnClick: true,
      hideProgressBar: quick,
    },
  )
}

const notify = {
  success: (text, options = {}) => baseNotify({
    title: 'Éxito',
    text,
    variant: 'success',
    icon: 'CheckCircleIcon',
    position: 'top-center', // default para success
    ...options, // si mandas otro position, lo sobrescribe
  }),

  error: (text, options = {}) => baseNotify({
    title: 'Error',
    text,
    variant: 'error',
    icon: 'AlertCircleIcon',
    position: 'top-right', // default para error
    ...options,
  }),

  warning: (text, options = {}) => baseNotify({
    title: 'Advertencia',
    text,
    variant: 'warning',
    icon: 'AlertTriangleIcon',
    position: 'top-right', // default para warning
    ...options,
  }),

  info: (text, options = {}) => baseNotify({
    title: 'Información',
    text,
    variant: 'info',
    icon: 'InfoIcon',
    position: 'bottom-left', // default para info
    ...options,
  }),

  custom: baseNotify,
}

/**
 * CASOS DE USO
 */

// Notificación rápida de éxito
// notify.success('Guardado correctamente', { quick: true })

// Error detallado
// notify.error('No se pudo conectar con el servidor')

// Advertencia con posición custom
// notify.warning('Tu sesión está por expirar', { position: 'bottom-right' })

// VARIANTES
// notify.warning('Documento no encontrado', { position: 'bottom-right' })
// notify.error('No se pudo conectar con el servidor')
// notify.success('Guardado correctamente', { quick: true, timeout: 3000 })

// Notificación totalmente personalizada
// notify.custom({
//   title: 'Mensaje especial',
//   text: 'Esto es un aviso custom',
//   variant: 'info',
//   position: 'top-center',
//   quick: false,
// })

export { notify }
export default notify
